<template>
  <a :href="match.slug" :title="match.title">
    <div
      class="as-match-item"
      :class="[
        `as-${sportType}`,
        {
          'as-is-hot': match.is_hot,
          'as-hide-footer': !isShowFooter,
          [`as-match-item-${siteName}`]: siteName,
        },
      ]"
    >
      <div class="as-match-item__header">
        <div class="as-match-item__league">
          <img
            v-if="competition"
            class="as-lazy"
            :class="`as-${sportType}`"
            :src="
              competition?.logo ||
              getImgUrlBySport('competition', match.competition_id)
            "
            :alt="
              competition.short_name ? competition.short_name : competition.name
            "
            width="24px"
            height="24px"
          />
          <span v-if="competition">{{ getCompetitionShortCode(competition)  }}</span>
        </div>
        <div class="as-match-item__time as-match-item__status--normal">
          <div
            v-if="
              (isH2h ||
              LIST_STATUS_PLAYING.includes(match.status_id)) &&
              match?.match_time_player
            "
            @mouseover="handleMouseStatisticOver"
            @mouseleave="handleMouseLeave"
            :class="`as-icon-haflt ${
              match?.match_time_player.status_h2h
                ? 'as-icon-haflt-' + match?.match_time_player.status_h2h
                : ''
            }`"
          >
            <span class="as-t_time_num">
              {{ match?.match_time_player?.text }}
            </span>
            <!-- <ProgressBar :match="match" /> -->
          </div>
        </div>
        <div class="as-match-item__date">
          {{ formatLocalTime(match.match_time, "h:mm DD/MM") }}
        </div>
      </div>
      <div class="as-match-item__body">
        <div class="as-match-item__team as-match-item__team-home as-team--home">
          <PlayerTennisNew
            :team="match.home_team"
            :match="match"
            :scores="getPT(match.scores)"
            :country="getImgUrlBySport('country', homeCountryId)"
            modifyClass="as-w-100 as-h2h as-flex-row-reverse"
          />
        </div>
        <div
          v-if="match.status_id === MatchEnum.STATUS_NOT_STARTED"
          class="as-match-item__status"
        >
          <span :class="`as-score-vs as-score-vs__28 as-score-vs__only-text as-score-vs__only-text-${siteName}`"
            >vs</span
          >
        </div>
        <div
          v-else
          @mouseover="handleMouseOver"
          @mouseleave="handleMouseLeave"
          class="as-match-item__status"
        >
          <span
            :class="`as-score-vs as-score-vs__num as-score-vs__28 as-score-vs-${siteName}`"
          >
            <span
              class="as-home-score"
              :class="{
                'as-winner': getFT(match.scores) > getFT(match.scores, true),
              }"
              >{{ getFT(match.scores) }}</span
            >
            <b>:</b>
            <span
              class="as-away-score"
              :class="{
                'as-winner': getFT(match.scores) < getFT(match.scores, true),
              }"
              >{{ getFT(match.scores, true) }}</span
            >
          </span>
        </div>

        <div class="as-match-item__team as-match-item__team-away as-team--away">
          <PlayerTennisNew
            :team="match.away_team"
            :match="match"
            :scores="getPT(match.scores)"
            :country="getImgUrlBySport('country', awayCountryId)"
            modeTeam="away-team"
            modifyClass="as-w-100 as-h2h as-flex-row"
          />
        </div>
      </div>
      <div v-if="isShowFooter" class="as-match-item__footer">
        <div v-if="match.commentator_id" class="as-commentator">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              d="M15.2328 2.96681L19.5921 6.134C21.5198 7.53454 22.3264 10.0171 21.5901 12.2832L19.925 17.4078C19.1887 19.6739 17.0769 21.2082 14.6942 21.2082H9.30583C6.92309 21.2082 4.81133 19.6739 4.07502 17.4078L2.40993 12.2832C1.67363 10.0171 2.48025 7.53454 4.40793 6.134L8.76718 2.96682C10.6949 1.56627 13.3051 1.56627 15.2328 2.96681Z"
              :fill="'url(#pattern_' + match.id + ')'"
              stroke="#FFC107"
            ></path>
            <path
              d="M8.76718 2.96682C10.6949 1.56627 13.3051 1.56627 15.2328 2.96681L19.5921 6.134C21.5198 7.53454 22.3264 10.0171 21.5901 12.2832L19.925 17.4078C19.1887 19.6739 17.0769 21.2082 14.6942 21.2082H9.30583C6.92309 21.2082 4.81133 19.6739 4.07502 17.4078L2.40993 12.2832C1.67363 10.0171 2.48025 7.53454 4.40793 6.134L8.76718 2.96682Z"
              stroke="#FFC107"
            ></path>
            <defs>
              <pattern
                :id="'pattern_' + match.id"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  :xlink:href="'#image_' + match.commentator_id"
                  transform="scale(0.000510204)"
                ></use>
              </pattern>
              <image
                :id="'image_' + match.commentator_id"
                width="1960"
                height="1960"
                :xlink:href="commentator ? commentator.avatar : ''"
              ></image>
            </defs>
          </svg>
          <span>{{ commentator ? commentator.name : "" }}</span>
        </div>
        <div
          v-if="
            match.status_id != MatchEnum.STATUS_NOT_STARTED && isShowFlagHalf
          "
          :class="`as-flag as-${sportType}`"
        >
          <div :class="`as-flag__team as-${sportType}`">
            {{ getTeamName(teams, match.home_team_id) }}
          </div>
          <span class="as-flag__score-list">
            <div
              v-for="(score, index) in matchScores['home']"
              :key="index"
              class="as-flag__score"
              :class="{
                'as-flag__score-win': score > matchScores['away'][index],
              }"
            >
              {{ score }}
              <span
                class="is_tie"
                v-if="
                  getMatchTieScores(match.scores, index, 0) &&
                  Number(getMatchTieScores(match.scores, index, 0)) > 0
                "
                :class="{
                  'as-bigger':
                    Number(getMatchTieScores(match.scores, index, 0)) > 9,
                }"
              >
                {{ getMatchTieScores(match.scores, index, 0) }}
              </span>
            </div>
          </span>
        </div>
        <div
          v-if="
            match.status_id != MatchEnum.STATUS_NOT_STARTED && isShowFlagHalf
          "
          :class="`as-flag as-${gSportType}`"
        >
          <div class="as-flag__team">
            {{ getTeamName(teams, match.away_team_id) }}
          </div>
          <span class="as-flag__score-list">
            <div
              v-for="(score, index) in matchScores['away']"
              :key="index"
              class="as-flag__score"
              :class="{
                'as-flag__score-win': score > matchScores['home'][index],
              }"
            >
              {{ score }}
              <span
                class="is_tie"
                v-if="
                  getMatchTieScores(match.scores, index, 1) &&
                  Number(getMatchTieScores(match.scores, index, 1)) > 0
                "
                :class="{
                  'as-bigger':
                    Number(getMatchTieScores(match.scores, index, 1)) > 9,
                }"
              >
                {{ getMatchTieScores(match.scores, index, 1) }}
              </span>
            </div>
          </span>
        </div>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { ref, computed, getCurrentInstance } from "vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";
import OddItem from "~src/modules/home/components/OddItem.vue";
import ProgressBar from "~src/components/matches/ProgressBar.vue";
import PlayerTennis from "~src/components/player/PlayerTennis.vue";
import PlayerTennisNew from "~src/components/player/PlayerTennisNew.vue";
import type {
  IMatch,
  IOdd,
  ITeam,
  ILeague,
  ICommentator,
} from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getTeamName } from "~src/helpers/tennis";
import { getOddValue } from "~src/helpers/OddHelper";
import { usecommonStore } from "~src/stores/CommonStore";
import type { IScores } from "~src/interfaces/tennis";
import { getScoresWithKey } from "~src/helpers";
import { convertScores } from "~src/interfaces/tennis";
import MatchEnumVolleyball from "~src/enums/volleyball/MatchEnum";


interface IProps {
  match: IMatch;
  odds?: Array<IOdd>;
  oddsOld?: Array<IOdd>;
  teams: Array<ITeam>;
  commentators: Array<ICommentator>;
  competitions: Array<ILeague> | any;
  isShowFlagHalf: boolean;
  isShowFooter: boolean;
  isH2h: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  odds: () => [],
  oddsOld: () => [],
  isShowFlagHalf: true,
  isShowFooter: true,
  isH2h: false,
});

const commonStore = usecommonStore();
const sportType = computed(() => commonStore.getSportType);

const LIST_STATUS_PLAYING = computed(() => {
  return sportType.value === "volleyball" ? MatchEnumVolleyball.LIST_STATUS_PLAYING : MatchEnum.LIST_STATUS_PLAYING
});
const siteName = computed(() => commonStore.getSiteName);
const odd = computed(() => {
  return props.odds.find((item: IOdd) => item.id === props.match.id);
});

const oddOld = computed(() => {
  return props.oddsOld.find((item: IOdd) => item.id === props.match.id);
});

const isShowOdd = computed(() => {
  let check = false;
  for (const key of [
    "asian_hdp",
    "asian_hdp_home",
    "asian_hdp_away",
    "asian_close",
    "european_home",
    "european_draw",
    "european_away",
    "european_close",
    "over_under_hdp",
    "over",
    "under",
    "over_under_close",
  ] as Array<string>) {
    if (getOddValue(odd.value, oddOld.value, key).value != "") {
      check = true;
    }
    break;
  }

  return check;
});

const competition = computed(() => {
  const compet: any = props.competitions.find(
    (item: ILeague) => item.id === props.match.competition_id
  );

  return compet;
});

const commentator = computed(() => {
  const compet: any = props.commentators.find(
    (item: ICommentator) => item.id === props.match.commentator_id
  );

  return compet;
});

const homeScores = props.match.home_scores || [];
const awayScores = props.match.away_scores || [];

const matchScores = computed(() => {
  const __scores = getScoresWithKey(convertScores(props.match.scores));
  return __scores;
});

const getMatchTieScores = (scores: any, index: number, mode = 0) => {
  // mode 0: Home
  // mode 1: Away
  const _index = Number(index) + 1;
  const xKey = `x${_index}`;
  const _x = scores[xKey] || ["", ""];

  return _x[mode];
};

const homeScoreTotal = computed(() => {
  return homeScores.reduce(
    (partialSum: number, a: number) => partialSum + a,
    0
  );
});

const awayScoreTotal = computed(() => {
  return awayScores.reduce(
    (partialSum: number, a: number) => partialSum + a,
    0
  );
});

const homeCountryId = computed(() => {
  const _team: any = props.teams.find((team: ITeam) => team.id === props.match.home_team_id);

  if(_team) {
    if( _team.country) {
      return _team.country.id;
    } else if( _team.country_id) {
      return _team.country_id;
    }
  }

  return "default";
});

const awayCountryId = computed(() => {
  const _team: any = props.teams.find((team: ITeam) => team.id === props.match.away_team_id);

  if(_team) {
    if( _team.country) {
      return _team.country.id;
    } else if( _team.country_id) {
      return _team.country_id;
    }
  }

  return "default";
});

const activeIncident = ref(false);
const activeHoverPopup = ref(false);
const activeStatistic = ref("");
let hideTimeout: number | undefined = undefined;

const handleMouseOverPopup = async (event: MouseEvent) => {
  activeHoverPopup.value = true;
};

const handleMouseLeavePopup = async (event: MouseEvent) => {
  activeHoverPopup.value = false;
  activeIncident.value = false;
};

const handleMouseOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "";
};

const handleMouseLeave = () => {
  // Use a timeout to avoid flickering
  setTimeout(() => {
    if (!activeHoverPopup.value) {
      activeIncident.value = false;
    }
  }, 100); // Adjust delay as needed
};

const handleMouseStatisticOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "statistic";
};

const getPT = (scores: IScores, is_away = false) => {
  let score = "";
  if (scores.pt && scores.pt.length) {
    score = scores.pt[0] ?? 0;
    if (is_away) {
      score = scores.pt[1] ?? 0;
    }
  }

  return score === "" ? 0 : score;
};

const getFT = (scores: IScores, is_away = false) => {
  let score = 0;
  if (scores.ft && scores.ft.length) {
    score = Number(scores.ft[0]);
    if (is_away) {
      score = Number(scores.ft[1]);
    }
  }

  return score;
};
</script>

<script lang="ts">
export default {};
</script>
